"use client"
import { Facepile as DSFacepile, type FacepileProps } from "@opensea/ui-kit"
import { AvatarImage } from "../Avatar"

export function Facepile(props: FacepileProps) {
  return (
    <DSFacepile
      {...props}
      overrides={{
        Avatar: { renderImage: AvatarImage, ...props.overrides?.Avatar },
        ...props.overrides,
      }}
    />
  )
}
